import { Button } from "@/components/ui/button"
import { Check, X, Eye } from "lucide-react"
import { useState } from "react"
import { sanitizeAiHtml } from "@/lib/sanitize-html"

export function AiSuggestion({ html, onApply, onDiscard, isParagraph }) {
  const [showPreview, setShowPreview] = useState(true)

  const sanitized = sanitizeAiHtml(html)

  return (
    <div className="rounded-lg border border-kf-red/20 bg-kf-red/5 p-3 space-y-3">
      <div className="flex items-center justify-between">
        <span className="text-xs font-medium text-kf-red uppercase tracking-wide">
          {isParagraph ? "Paragraph Suggestion" : "Article Suggestion"}
        </span>
        <Button
          variant="ghost"
          size="sm"
          className="h-6 px-2 text-xs text-zinc-500 hover:text-zinc-700"
          onClick={() => setShowPreview(!showPreview)}
        >
          <Eye className="h-3 w-3 mr-1" />
          {showPreview ? "Hide" : "Preview"}
        </Button>
      </div>

      {showPreview && (
        <div
          className="prose prose-sm prose-zinc max-w-none rounded border border-zinc-200 bg-white p-3 max-h-64 overflow-y-auto"
          dangerouslySetInnerHTML={{ __html: sanitized }}
        />
      )}

      <div className="flex items-center gap-2">
        <Button
          variant="gradient"
          size="sm"
          className="h-7 text-xs"
          onClick={() => onApply(sanitized)}
        >
          <Check className="h-3 w-3 mr-1" />
          Apply
        </Button>
        <Button
          variant="outline"
          size="sm"
          className="h-7 text-xs"
          onClick={onDiscard}
        >
          <X className="h-3 w-3 mr-1" />
          Discard
        </Button>
      </div>
    </div>
  )
}
